<template lang="pug">
.field
  el-form
    el-form-item(label='Title')
      el-input(v-model='field.title' :disabled='disabled')

    el-form-item(label='Description')
      el-input(v-model='field.properties.description.value' :disabled='disabled')

    el-row(:gutter='10')

      el-col(:span='6')
        el-form-item(label='Randomise')
          el-switch(v-model='field.properties.randomize.value' on-text="" off-text="" :disabled='disabled')

      el-col(:span='6')
        el-form-item(label='Allow multiple selection')
          el-switch(v-model='field.properties.allowMultipleSelection.value' on-text="" off-text="" :disabled='disabled')

      el-col(:span='6')
        el-form-item(label='Allow "other" choice')
          el-switch(v-model='field.properties.allowOtherChoice.value' on-text="" off-text="" :disabled='disabled')

      el-col(:span='6')
        el-form-item(label='Vertical alignment')
          el-switch(v-model='field.properties.verticalAlignment.value' on-text="" off-text="" :disabled='disabled')

    .options
      .option(v-for='(option, optionIndex) in field.properties.choices.options' :key='optionIndex')
        .option-field
          el-form-item(:label='`Choice ${optionIndex + 1}:`')
            el-input(v-model='option.value' placeholder='Enter choice...' :disabled='disabled')
        .option-remove(@click='removeOption(optionIndex)' v-if='!disabled')
          icon(name="times" color='#999')

      el-button(@click='addOption' v-if='!disabled') + Add option

</template>

<script>
export default {
  props: {
    field: {
      type: Object
    },
    disabled: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  methods: {
    addOption() {
      this.field.properties.choices.options.push({ value: "" });
    },
    removeOption(index) {
      this.field.properties.choices.options.splice(index, 1);
    }
  }
};
</script>

<style scoped lang="scss">
.option {
  display: flex;
  align-items: center;
}

.option-field {
  flex: 1;
  margin-right: 10px;
}

.option-remove {
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: auto;
  display: flex;
  align-items: center;
}
</style>
